import {
    DeleteParkingRateEditBatchAction,
    GetAllProposedParkingRateRegulationsAction,
    GetParkingRateListViewFiltersAction,
    IsEditParkingRatesEnabledAction,
    ParkingRateListViewFiltersReceivedAction,
    ProposedParkingRateRegulationsReceivedAction,
    SetChosenParkingRatesAction,
    SetDisabledIdsAction,
    SetRegulationTypeAction,
    ShowParkingRateListViewAction,
    ToggleEditParkingRatesOptionsPanelAction,
    DELETE_PARKING_RATE_EDIT_BATCH,
    GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS,
    GET_PARKING_RATE_LIST_VIEW_FILTERS,
    IS_EDIT_PARKING_RATES_IN_PROGRESS,
    PARKING_RATE_LIST_VIEW_FILTERS_RECEIVED,
    PROPOSED_PARKING_RATE_REGULATIONS_RECEIVED,
    SET_CHOSEN_PARKING_RATES,
    SET_DISABLED_IDS,
    SET_REGULATION_TYPE,
    SHOW_PARKING_RATE_LIST_VIEW,
    STORE_PROPOSED_PARKING_RATE_REGULATIONS_PARAMS,
    TOGGLE_EDIT_PARKING_RATES_OPTIONS_PANEL,
    TOGGLE_PARKING_RATES_ACTION_PERFORMED,
    showParkingBatchListViewAction,
    SHOW_PARKING_BATCH_LIST_VIEW,
    ProposedParkingBatchRegulationsReceivedAction,
    PROPOSED_PARKING_BATCH_REGULATIONS_RECEIVED,
    SelectedParkingRateColumnsAction,
    SELECTED_PARKING_RATE_COLUMNS,
    GetSelectedParkingRateBatchData,
    GET_SELECTED_PARKING_RATE_BATCH_DATA
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const setRegulationType =
    createAction<SetRegulationTypeAction["payload"]>(SET_REGULATION_TYPE);

export const setChosenParkingRates =
    createAction<SetChosenParkingRatesAction["payload"]>(SET_CHOSEN_PARKING_RATES);

export const toggleEditParkingRatesOptionsPanel = createAction<
    ToggleEditParkingRatesOptionsPanelAction["payload"]
>(TOGGLE_EDIT_PARKING_RATES_OPTIONS_PANEL);

export const toggleParkingRateActionPerformed = createAction(TOGGLE_PARKING_RATES_ACTION_PERFORMED);

export const setDisabledIds = createAction<SetDisabledIdsAction["payload"]>(SET_DISABLED_IDS);

export const isEditParkingRatesInProgress = createAction<
    IsEditParkingRatesEnabledAction["payload"]
>(IS_EDIT_PARKING_RATES_IN_PROGRESS);

export const getAllProposedParkingRateRegulations = createAction<
    GetAllProposedParkingRateRegulationsAction["payload"]
>(GET_ALL_PROPOSED_PARKING_RATE_REGULATIONS);

export const proposedParkingRateRegulationsReceived = createAction<
    ProposedParkingRateRegulationsReceivedAction["payload"]
>(PROPOSED_PARKING_RATE_REGULATIONS_RECEIVED);

export const showParkingRateListView = createAction<ShowParkingRateListViewAction["payload"]>(
    SHOW_PARKING_RATE_LIST_VIEW
);

export const proposedParkingBatchRegulationsReceived = createAction<
    ProposedParkingBatchRegulationsReceivedAction["payload"]
>(PROPOSED_PARKING_BATCH_REGULATIONS_RECEIVED);

export const showParkingBatchListView = createAction<showParkingBatchListViewAction["payload"]>(
    SHOW_PARKING_BATCH_LIST_VIEW
);

export const getSelectedParkingRateBatchData = createAction<
    GetSelectedParkingRateBatchData["payload"]
>(GET_SELECTED_PARKING_RATE_BATCH_DATA);

export const storeProposedParkingRateRegulationsParams = createAction<
    GetAllProposedParkingRateRegulationsAction["payload"]
>(STORE_PROPOSED_PARKING_RATE_REGULATIONS_PARAMS);

export const deleteParkingRateEditBatch = createAction<DeleteParkingRateEditBatchAction["payload"]>(
    DELETE_PARKING_RATE_EDIT_BATCH
);

export const getParkingRateListViewFilters = createAction<
    GetParkingRateListViewFiltersAction["payload"]
>(GET_PARKING_RATE_LIST_VIEW_FILTERS);

export const parkingRateListViewFiltersReceived = createAction<
    ParkingRateListViewFiltersReceivedAction["payload"]
>(PARKING_RATE_LIST_VIEW_FILTERS_RECEIVED);

export const setSelectedParkingRateColumns = createAction<
    SelectedParkingRateColumnsAction["payload"]
>(SELECTED_PARKING_RATE_COLUMNS);
